const getNorthVariations = (commonCanopies, commonVariaton) => {
	const northBase = {
		...commonVariaton,
		familyName: 'north',
		related: ['5664', '5662', '5660'],
		canopy: {
			...commonCanopies,
			"10": {
				...commonCanopies['10'],
				source: '/models/canopy_north.glb',
				size: {
					width: 0.18,
					depth: 0.18,
					height: 0.04
				},
			}
		},
		light: {
			type: 'spot',
			power: 755
		}
	}

	return {
		'5664': {
			...northBase,
			size: {
				width: 0.6,
				height: 0.21,
				depth: 0.6
			},
			light: {
				...northBase.light,
				options: { angle: Math.PI / 2.8 }
			}
		},
		'5662': {
			...northBase,
			size: {
				width: 0.4,
				height: 0.25,
				depth: 0.4
			},
			light: {
				...northBase.light,
				options: { angle: Math.PI / 6 }
			}
		},
		'5660': {
			...northBase,
			size: {
				width: 0.16,
				height: 0.135,
				depth: 0.16
			},
			light: {
				...northBase.light,
				options: { angle: Math.PI / 6 }
			}
		}
	}
}

export default getNorthVariations